/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type prospectkpis_ProspectKpiDropOffByReasonResponse = {
    /**
     * ArchivedReasonCode is one of the six archive reason codes a drop-off can carry.
     * The contract-completed code (migration 167) is a conversion, not a drop-off, and
     * is never a key here. The enum list MUST stay in step with
     * services.ProspectKpiDropOffReasonCodes(): ByReason below is zero-filled over that
     * list, so a missing value here would ship a key the generated clients cannot name.
     */
    archived_reason_code: prospectkpis_ProspectKpiDropOffByReasonResponse.archived_reason_code;
    /**
     * Count is the number of archive events recorded under that code.
     */
    count: number;
};
export namespace prospectkpis_ProspectKpiDropOffByReasonResponse {
    /**
     * ArchivedReasonCode is one of the six archive reason codes a drop-off can carry.
     * The contract-completed code (migration 167) is a conversion, not a drop-off, and
     * is never a key here. The enum list MUST stay in step with
     * services.ProspectKpiDropOffReasonCodes(): ByReason below is zero-filled over that
     * list, so a missing value here would ship a key the generated clients cannot name.
     */
    export enum archived_reason_code {
        NO_INTEREST = 'no_interest',
        NO_CAPACITY = 'no_capacity',
        PRICE = 'price',
        OTHER_SOLUTION = 'other_solution',
        NO_SHOW = 'no_show',
        OTHER = 'other',
    }
}

